// extracted by mini-css-extract-plugin
export var sliderRange = "_p6-2";
export var sliderRoot = "_p6-0";
export var sliderThumb = "_p6-3";
export var sliderTrack = "_p6-1";